import Home from './components/home/Home'
import NarabiMethod from './components/home/NarabiMethod'
import Competencies from './components/home/Competencies'
import References from './components/home/References'
import Contact from './components/home/Contact'
import FundaChecker from './components/etc/FundaChecker'

export const routes = [
  {
    path: '/',
    redirect: { name: 'home' }
  },
  {
    path: '/home',
    name: 'home',
    component: Home
  },
  {
    path: '/NarabiMethod',
    name: 'NarabiMethod',
    component: NarabiMethod
  },
  {
    path: '/competencies',
    name: 'competencies',
    component: Competencies
  },
  {
    path: '/references',
    name: 'references',
    component: References
  },
  {
    path: '/contact',
    name: 'contact',
    component: Contact
  },
  {
    path: '/FundaChecker',
    name: 'FundaChecker',
    component: FundaChecker
  }
]
